/** @format */

//importing components
import DynamicTable from "../components/global/DynamicTable";
//import components
import HeadTitle from "../components/global/HeadTitle";

import Grid from "../components/dashboard/grid";
import PieChart from "../components/dashboard/pieChart";
import ProgressChart from "../components/dashboard/progress-chart";

//import assets
import { IoIosArrowRoundBack } from "react-icons/io";

//import table data
import { tableColumnDashboard } from "../components/table/col-data";
import { ClientPop } from "./guarantor/pops/pops";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDashboard } from "../services/dashboard";
import { Spinner1 } from "../components/spinners/Spinner1";
import NavbarAndSidebar from "../components/NavbarAndSidebar";

const Dashboard = ({ data }) => {
  //redux
  const dispatch = useDispatch();
  const dashboard = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getDashboard({ url: "/home" }));
  }, []);

  return (
    <NavbarAndSidebar>
      {dashboard.loading && <Spinner1 />}

      <HeadTitle title='لوحة التحكم' margin={true} />
      <Grid data={dashboard.stats} />
      <div className='mb__small' />
      <div className='dashboard-charts'>
        <div className='dashboard-charts__box dashboard-charts__box--pie'>
          <HeadTitle title=' احصائيات طلبات الخدمات ' margin={true} />

          <div className='dashboard-charts__pie'>
            <PieChart data={dashboard.stats} />
          </div>
        </div>
        <div className='dashboard-charts__box dashboard-charts__box--progress'>
          <div className='dashboard-charts__progress'>
            <ProgressChart />
          </div>
        </div>
      </div>
      <div className='mb__small' />

      {/* <div className="flex-between">
          <HeadTitle title="طلبات قيد الانتظار " />
          <p
            to="/forget-password"
            className="input__forget-pass"
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            المزيد
            <IoIosArrowRoundBack className="react-icon" />
          </p>
        </div>

        <div className="mb__small" />
        <DynamicTable tableColumn={tableColumnDashboard} /> */}
    </NavbarAndSidebar>
  );
};
export default Dashboard;
